import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
export const makeHoC = useHooks => {
  return Component => {
    const HooksProvider = props => {
      return /*#__PURE__*/React.createElement(Component, Object.assign({}, useHooks(props), props));
    };
    HooksProvider.displayName = `makeHoC(${Component.displayName || Component.name || 'Component'})`;
    return hoistNonReactStatics(HooksProvider, Component);
  };
};
//# sourceMappingURL=make-hoc.js.map